<template>
    <div>
        <div class="d-flex d-lg-none">
            <DrawerComponent ref="drawer"></DrawerComponent>
        </div>
        <div id="navbar" class="d-none d-lg-flex header flex-row fixed-top blue-background"
            v-bind:class="{ hidden: navbarHidden }">
            <div class="col-2 d-flex align-items-center">
                <router-link to="/" @click="hideDrawer();">
                    <img class="align-self-center" style="height:40px; margin-left:40px" src="@/assets/logo.svg" />
                </router-link>
            </div>
            <div class="col-8 d-flex justify-content-center align-items-center">
                <router-link class="navitem" to="/about">{{ $t('about_us_title') }}</router-link>
                <!-- <router-link to="/programs">Программы</router-link> -->

                <b-dropdown id="dropdown-1" class="m-md-2">
                    <template #button-content>
                        <div class="d-flex ddn">
                            <p style="margin:0;">{{ $t('programs') }}</p>
                        </div>
                    </template>
                    <b-dropdown-item to="/highschool">{{ $t('higher_edu_title') }}</b-dropdown-item>
                    <b-dropdown-item to="/middleschool">{{ $t('ms_title') }}</b-dropdown-item>
                    <b-dropdown-item to="/languagecourses">{{ $t('lc_title') }}</b-dropdown-item>
                    <b-dropdown-item to="/scholarship">{{ $t('scholar_title') }}</b-dropdown-item>
                </b-dropdown>
                <!-- <router-link class="navitem" to="/stats">Акции</router-link> -->
                <router-link class="navitem" to="/countries">{{ $t('abroad_edu') }} </router-link>
                <router-link class="navitem" to="/articles">{{ $t('articles') }}</router-link>
                <router-link class="navitem" to="/contacts">{{ $t('contacts') }}</router-link>
            </div>
            <!-- </div> -->
            <div class="col-2 d-flex align-items-center justify-content-center">
                <LanguageSelectComponent></LanguageSelectComponent>
            </div>
        </div>
        <div class="d-flex d-lg-none justify-content-between align-items-center header p-3 fixed-top blue-background">
            <div class="p-3 align-self-left" @click="showDrawer();">
                <img src="@/assets/hamburger.svg" alt="" />
            </div>
            <router-link class="align-self-center" @click.native="hideDrawer();" to="/">
                <img class="align-self-center" style="height:30px;" src="@/assets/logo.svg" />
            </router-link>
            <div class="p-2"></div>
        </div>
    </div>
</template>

<script>
import DrawerComponent from "./DrawerComponent.vue";
import LanguageSelectComponent from "./LanguageSelectComponent.vue";
export default {
    data() {
        return {
            lastYOffset: 0,
            navbarHidden: false
        }
    },
    mounted() {

        window.onscroll = () => {
            // called when the window is scrolled.  
            // console.log(e);
            if (window.scrollY > this.lastYOffset) {
                console.log('down');
                this.hideHeader();
            } else {
                console.log('up');
                this.showHeader();
            }
            this.lastYOffset = window.scrollY;
            // console.log(this.navbarHidden);
        }
    },
    methods: {
        showDrawer() {
            this.$refs.drawer.open();
        },
        hideDrawer() {

            this.$refs.drawer.close();
        },
        showHeader() { this.navbarHidden = false; }, hideHeader() { this.navbarHidden = true; },
    },
    components: {
        DrawerComponent,
        LanguageSelectComponent
    }
}
</script>

<style lang="css">
.header {

    color: white;
    height: 90px;
    z-index: 15;
    border-radius: 0 0 30px 30px;
    transition: all .2s ease-out;

}

.hidden {
    transform: translate(0, -100%);
}

.navitem {
    color: white !important;
    margin: 1rem;
}

a:hover {
    text-decoration: none;
}

.dropdown-toggle:after {
    content: none
}

.dropdown-toggle {
    background-color: transparent;
    border: none;
}

.dropdown-toggle:hover {
    background-color: transparent;
}

.b-dropdown.show {}

.dropdown-menu {
    background-color: #0a1266;
    border-radius: 0 0 30px 30px;
    border: none;
    margin: 0;
    padding: 30px;
    transform: translate(0, 84px) !important;
}

.show>.dropdown-toggle {
    background-color: transparent !important;
}

.dropdown-toggle {
    border: none !important;
}

.btn:active {
    background-color: transparent;
    border: none;
    box-shadow: none;
}

.btn:focus {
    background-color: transparent !important;
    outline: none !important;
    border: none !important;
    box-shadow: none;
    border-color: transparent !important;
}

.dropdown-item:hover {

    text-decoration-line: underline;
    background-color: transparent !important;
}


.dropdown-item {
    color: white !important;
}

.lang-switch {
    cursor: pointer;
}

.ddn {
    padding: 27px;
}
</style>
